//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
import * as s from "./ChromeNavContent.styles";
// other components
import { LogoClock } from "@components/logo";
// state
import { IReduxState } from "@reducers/root.reducer";
import {
  setActiveViewFeed,
  setActiveViewDay,
  setActiveViewTeamHealth,
  setActiveViewAutopilotList,
  setActiveViewEvent,
} from "@actions/chrome-extension.actions";
// util
import { ChromeAppWrapperView } from "@util/chrome-extension.util";
// material-ui
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import { IconButton, Tooltip } from "@material-ui/core";
import { ChevronLeft } from "@material-ui/icons";

//////////////////
// TYPES
//////////////////
interface IContainer {
  backDestination?: ChromeAppWrapperView;
  onBack?: () => void;
}

interface IProps extends IContainer, WithStyles<typeof s.styles> {
  setActiveViewFeed: typeof setActiveViewFeed;
  setActiveViewDay: typeof setActiveViewDay;
  setActiveViewTeamHealth: typeof setActiveViewTeamHealth;
  setActiveViewAutopilotList: typeof setActiveViewAutopilotList;
  setActiveViewEvent: typeof setActiveViewEvent;
}

interface IState {}

//////////////////
// COMPONENT
//////////////////
class ChromeNavBackBtnCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  private onClick = () => {
    switch (this.props.backDestination) {
      case ChromeAppWrapperView.TeamHealth:
        this.props.setActiveViewTeamHealth();
        break;
      case ChromeAppWrapperView.AutopilotList:
        this.props.setActiveViewAutopilotList();
        break;
      case ChromeAppWrapperView.Day:
        this.props.setActiveViewDay();
        break;
      case ChromeAppWrapperView.Feed:
      default:
        this.props.setActiveViewFeed();
        break;
    }

    if (this.props.onBack) {
      this.props.onBack();
    }
  };

  private toolTipLabel = () => {
    switch (this.props.backDestination) {
      case ChromeAppWrapperView.TeamHealth:
        return "Teammates";
      case ChromeAppWrapperView.Feed:
      default:
        return "Home"; // FIXME
    }
  };

  public render() {
    const toolTip = this.toolTipLabel();

    return (
      <Tooltip title={toolTip} placement="bottom">
        <IconButton
          className={this.props.classes.backBtn}
          onClick={() => this.onClick()}
          disableRipple={true}
          cw-id="chrome-nav-back-button"
        >
          <div className={this.props.classes.backBtnContent}>
            <ChevronLeft style={s.backBtnChevron} />
            <LogoClock size={s.backBtnLogo.width} fill={s.backBtnLogo.fill} />
          </div>
        </IconButton>
      </Tooltip>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
const ChromeNavBackBtnStyled = withStyles(s.styles)(ChromeNavBackBtnCmpt);

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

export const ChromeNavBackBtn = connect(mapStateToProps, {
  setActiveViewFeed,
  setActiveViewDay,
  setActiveViewTeamHealth,
  setActiveViewAutopilotList,
  setActiveViewEvent,
})(ChromeNavBackBtnStyled);
